module.exports = __webpack_public_path__ + "img/17_19.d9fb9d72.png";